"use client";

import { useEffect, useState } from "react";
import { DreamCarWithCompetition } from "./dreamCar";
import { ToastProvider } from "../../../components/ToastNotification/toastProvider";
import Stepper from "./stepper";
import { getUmbracoGrid } from "../../../common-service";
import { GridProps } from "../../../common";

const DreamCarCompetition = () => {
  const [data, setData] = useState<GridProps>({
    botbGridContent: {},
  });

  useEffect(() => {
    (async () => {
      try {
        const response = await getUmbracoGrid();
        const dreamCarData = (await response.json()) as GridProps;
        setData(dreamCarData);
      } catch (err) {
        console.error(`Error while fetching the dream car grid - ${JSON.stringify(err)}`);
      }
    })();
  }, []);

  return (
    <>
      <Stepper />
      <DreamCarWithCompetition botbGridContent={data?.botbGridContent} />
      <ToastProvider />
    </>
  );
};

export default DreamCarCompetition;
